export const colXsProps = {
  xs: 24,
  md: 6,
};

export const colSmProps = {
  xs: 24,
  md: 10,
};

export const colMdProps = {
  xs: 24,
  md: 12,
};

export const colLgProps = {
  xs: 24,
};